import LoginReducer from "./Store/Login/LoginReducer";
import MastersReducer from "./Store/Masters/MastersReducer";
import DashboardReducer from "./Store/Dashboard/DashboardReducer";
import AshaAnmSectionReducer from "./Store/Dashboard/AshaAnmSection/AshaAnmSectionReducer";
import AnmSectionReducer from "./Store/Dashboard/AshaAnmSection/AnmSectionReducer";
import ProfileSettingReducer from "./Store/Profile/ProfileSettingReducer";
import IECModuleReducer from "./Store/IECModule/IECModuleReducer";
import NewUserReducer from "./Store/newUser/NewUserReducer";
import DropdownMastersReducer from "./Store/Masters/DropdownMasters/DropdownMastersReducer";import ANMReducer from "./Store/ANMDetails/ANMReducer";


const rootReducer = {
  login: LoginReducer,
  dashboard: DashboardReducer,
  profilesettings: ProfileSettingReducer,
  ashaAnmSection: AshaAnmSectionReducer,
  AnmSectionReducer: AnmSectionReducer,
  masters: MastersReducer,
  dropdownMasters: DropdownMastersReducer,
  iecmodule: IECModuleReducer,
  newuser: NewUserReducer,
  anmDetails:ANMReducer,

};

export default rootReducer;
